function percentile(sortedValues, ratio) {
  if (!sortedValues.length) return 0
  const idx = Math.min(sortedValues.length - 1, Math.max(0, Math.floor(sortedValues.length * ratio)))
  return sortedValues[idx]
}

const COMMON_REFRESH_RATES = [30, 50, 60, 75, 90, 100, 120, 144, 165, 240]

export function estimateRefreshRate(deltas, fallback = 60) {
  const usable = deltas.filter(v => Number.isFinite(v) && v > 0).sort((a, b) => a - b)
  if (usable.length < 12) return fallback
  const fastFrameMs = percentile(usable, 0.1)
  const rawFps = 1000 / fastFrameMs
  return COMMON_REFRESH_RATES.reduce((best, fps) =>
    Math.abs(fps - rawFps) < Math.abs(best - rawFps) ? fps : best
  , COMMON_REFRESH_RATES[0])
}

export function summarizeFrameDeltas(deltas, targetFps = 60) {
  if (!deltas.length) {
    return {
      fps: 0,
      avgMs: 0,
      lowFps: 0,
      worstMs: 0,
      status: 'idle',
    }
  }
  const avgMs = deltas.reduce((sum, v) => sum + v, 0) / deltas.length
  const sorted = [...deltas].sort((a, b) => a - b)
  const worstMs = sorted[sorted.length - 1]
  const p95Ms = percentile(sorted, 0.95)
  const fps = avgMs > 0 ? 1000 / avgMs : 0
  const lowFps = p95Ms > 0 ? 1000 / p95Ms : 0
  const status = lowFps >= targetFps * 0.85
    ? 'good'
    : lowFps >= targetFps * 0.55
      ? 'warn'
      : 'bad'

  return {
    fps,
    avgMs,
    lowFps,
    worstMs,
    status,
  }
}

/** Rolling window of rAF frame deltas; `reset()` forgets the last timestamp so a suspended gap isn't sampled. */
export function createFrameSampler(sampleSize) {
  let lastTs = 0
  const deltas = []
  return {
    deltas,
    push(ts) {
      if (lastTs > 0) {
        deltas.push(ts - lastTs)
        if (deltas.length > sampleSize) deltas.splice(0, deltas.length - sampleSize)
      }
      lastTs = ts
    },
    reset() {
      lastTs = 0
      deltas.length = 0
    },
  }
}
